<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M12.77 6.38001L9.99 9.16001M9.99 9.16001L7.22 6.38001M9.99 9.16001V3.05001M18 10.82H13.04V11.93C13.04 12.2244 12.9231 12.5067 12.7149 12.7149C12.5067 12.9231 12.2244 13.04 11.93 13.04H8.05C7.75561 13.04 7.47328 12.9231 7.26511 12.7149C7.05695 12.5067 6.94 12.2244 6.94 11.93V10.82H1.98M13.32 3.05001H13.47C13.9169 3.04939 14.3535 3.18365 14.7228 3.43522C15.0922 3.68678 15.377 4.04395 15.54 4.46001L17.88 10.43C17.98 10.69 18.03 10.96 18.04 11.24V14.71C18.04 15.2988 17.8061 15.8635 17.3898 16.2798C16.9734 16.6961 16.4088 16.93 15.82 16.93H4.16C3.57122 16.93 3.00656 16.6961 2.59023 16.2798C2.17389 15.8635 1.94 15.2988 1.94 14.71V11.24C1.94 10.96 1.99 10.69 2.1 10.43L4.44 4.46001C4.60305 4.04395 4.88785 3.68678 5.25717 3.43522C5.6265 3.18365 6.06314 3.04939 6.51 3.05001H6.66"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
